import React from 'react';

const CheckRoundSVG = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.16078 7.44061C5.84078 7.12061 5.36078 7.12061 5.04078 7.44061C4.72078 7.76061 4.72078 8.24061 5.04078 8.56061L7.44078 10.9606C7.60078 11.1206 7.76078 11.2006 8.00078 11.2006C8.24078 11.2006 8.40078 11.1206 8.56078 10.9606L14.1608 4.56061C14.4008 4.16061 14.4008 3.68061 14.0008 3.44061C13.6808 3.20061 13.2008 3.20061 12.9608 3.52061L8.00078 9.20061L6.16078 7.44061Z"
        fill="#076CEC"
      />
      <path
        d="M15.2 7.2C14.72 7.2 14.4 7.52 14.4 8C14.4 11.52 11.52 14.4 8 14.4C4.48 14.4 1.6 11.52 1.6 8C1.6 6.32 2.24 4.72 3.44 3.52C4.64 2.24 6.24 1.6 8 1.6C8.48 1.6 9.04 1.68 9.52 1.76C9.92 1.92 10.4 1.68 10.56 1.2C10.72 0.72 10.4 0.4 10 0.24H9.92C9.28 0.08 8.64 0 8 0C3.6 0 0 3.6 0 8.08C0 10.16 0.88 12.24 2.32 13.68C3.84 15.2 5.84 16 7.92 16C12.32 16 15.92 12.4 15.92 8C16 7.52 15.6 7.2 15.2 7.2Z"
        fill="#076CEC"
      />
    </svg>
  );
};

export default CheckRoundSVG;
